import { v4 as uuid } from "uuid";

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    _id: uuid(),
    categoryName: "All",
  },
  {
    _id: uuid(),
    categoryName: "Macrame",
  },
  {
    _id: uuid(),
    categoryName: "Mandala Designs",
  },
  {
    _id: uuid(),
    categoryName: "DreamCatcher",
  },
  {
    _id: uuid(),
    categoryName: "Decoration",
  },
  
];
